module.exports = __webpack_public_path__ + "static/media/settings.1294fd6d.svg";